import React from "react";
import { RouteComponentProps } from "../../models/RouteComponent";
import {TabPanel, TabView} from "primereact/tabview";
import BillingUsageTable from "./billing-UsageTable";
import BillingPricingView from "./billing-Pricing-View";
import BillingSystemTable from "./billing-SystemTable";


export default function BillingView(props: RouteComponentProps) {

  return (
    <React.Fragment>

      <TabView>
        <TabPanel header="Usage">
          <BillingUsageTable {...props} />
        </TabPanel>
        <TabPanel header="Pricing">
          <BillingPricingView {...props} />
        </TabPanel>
        <TabPanel header="System">
          <BillingSystemTable {...props} />
        </TabPanel>
      </TabView>

    </React.Fragment>
  );
}